import { Colors, Intent, Spinner } from "@blueprintjs/core";

import { Flex } from "@/components/layout/flexbox";

interface LoadingOverlayProps {
  intent?: Intent;
  style?: React.CSSProperties;
}

export function LoadingOverlay({
  intent = Intent.PRIMARY,
  style = {},
}: LoadingOverlayProps) {
  return (
    <Flex
      justifyContent="center"
      p={2}
      opacity={0.5}
      bg={Colors.WHITE}
      style={{
        zIndex: 3000,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...style,
      }}
    >
      <Spinner intent={intent} />
    </Flex>
  );
}
